import { useEffect, useState } from "react";
import CustomHr from "../components/CustomHr.jsx";
import PageContainer from "../components/PageContainer.jsx";
import PageTitle from "../components/PageTitle.jsx";
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
import Loader from '../components/Loader.jsx';
import Error from '../components/Error.jsx';
import { GreenButton } from '../components/buttons.js';

const SetShippingData = () => {
    const { t } = useTranslation();
    const token = localStorage.getItem('ticino-wild-token');
    const { id } = useSelector(state => state.user);

    // Verifico all'atterraggio in pagina se è una edit
    const [inputData, setInputData] = useState({
        userId: id || null,
        city: null,
        postalCode: null,
        address: null
    });
    const [editStatus, setEditStatus] = useState('idle');
    const [editError, setEditError] = useState(null);
    const { isUserShopOrderAvailable } = useSelector(state => state.user);
    const getUserData = async () => {
        setEditStatus('loading');
        const url = `${process.env.REACT_APP_SERVER_BASE_URL}/users/get-shipping-data/${id}`;
        const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
        const options = { method: 'GET', headers };
        try {
            const response = await fetch(url, options);
            if (response.ok) {
                const result = await response.json();
                if (result.isUserShopOrderAvailable) setInputData(prevState => ({ ...prevState, ...result.payload }));
                setEditStatus('succeeded');
            } else {
                const error = await response.json();
                throw new Error(error);
            }
        } catch (error) {
            setEditError(error.message || "Errore nella chiamata di verifica isEdit. Ricarica la pagina e riprova")
            setEditStatus('failed')
        }
    }
    useEffect(() => {
        if (isUserShopOrderAvailable) getUserData();
    }, [isUserShopOrderAvailable])

    // Gestisco la compilazione degli input
    const handleInputData = (event) => {
        const { id, value } = event.target;
        setInputData(prevState => ({
            ...prevState,
            [id]: value
        }))
    }
    // Invio i dati al backend
    const [fetchStatus, setFetchStatus] = useState('idle');
    const [error, setError] = useState(null);
    const sendData = async () => {
        setFetchStatus('loading');
        const url = `${process.env.REACT_APP_SERVER_BASE_URL}/users/set-shipping-data`;
        const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
        const options = { method: 'POST', headers, body: JSON.stringify(inputData) };
        try {
            const response = await fetch(url, options);
            if (response.ok) {
                const result = await response.json();
                setFetchStatus('succeeded');
            } else {
                const error = await response.json();
                throw new Error(error)
            }
        } catch (error) {
            setError(error.message || "Errore nell'invio dei dati al server. Ricarica la pagina e riprova.")
            setFetchStatus('failed')
        }
    }

    // Gestisco il redirect finale (se l'utente arriva da un tentativo di acquisto, sarà rimandato alla pagina dettaglio del prodotto in shop che ha tentato di acquistare)
    const { link } = useSelector(state => state.backlink);

    useEffect(() => {
        if (fetchStatus === 'succeeded') {
            setTimeout(() => {
                window.location.href = "/my-profile"
            }, 3000)
        }
    }, [fetchStatus])

    // Verifico che tutti i campi siano compilati
    const [isAllFields, setIsAllFields] = useState(false);
    useEffect(() => {
        if(inputData.city && inputData.postalCode && inputData.address) {
            setIsAllFields(true)
        } else {
            setIsAllFields(false)
        }
    }, [inputData])

    return (
        <PageContainer px="4" items="center">
            <PageTitle title={t('SetShippingData.PageTitle')} backLink="/" />
            {
                editStatus === 'loading' &&
                <Loader />
            }
            {
                editStatus === 'failed' &&
                <Error message={editError} />
            }
            {
                (editStatus === 'succeeded' || editStatus === 'idle') &&
                <div className="flex flex-col items-center">
                    <h3 className="text-[#225424] my-8">{t('SetShippingData.insertYourAddress')}</h3>
                    {/* Informazioni generali */}
                    <h2 className="mt-8">{t('SetShippingData.addressData')}</h2>
                    <CustomHr />
                    <div className="flex flex-col w-full max-w-[400px]">
                        {/* Città */}
                        <div className="flex flex-col p-2 gap-2">
                            <label htmlFor="city">{t('SetShippingData.city')}</label>
                            <input type="text" id="city" value={inputData.city || null} onChange={handleInputData} />
                        </div>
                        {/* CAP */}
                        <div className="flex flex-col p-2 gap-2">
                            <label htmlFor="postalCode">{t('SetShippingData.postalCode')}</label>
                            <input type="number" id="postalCode" value={inputData.postalCode || null} onChange={handleInputData} />
                        </div>
                        {/* Indirizzo e numero civico */}
                        <div className="flex flex-col p-2 gap-2">
                            <label htmlFor="address">{t('SetShippingData.address')}</label>
                            <input type="text" id="address" value={inputData.address || null} onChange={handleInputData} />
                        </div>
                        <div className="ml-2 mt-8 w-full">
                            {
                                fetchStatus === 'idle' && isAllFields &&
                                <GreenButton text={t('SetShippingData.sendButton')} click={sendData} />
                            }
                            {
                                fetchStatus === 'idle' && !isAllFields &&
                                <GreenButton disabled text={t('SetShippingData.sendButton')} />
                            }
                            {
                                fetchStatus === 'loading' &&
                                <Loader />
                            }
                            {
                                fetchStatus === 'failed' &&
                                <Error message={error} />
                            }
                            {
                                fetchStatus === 'succeeded' &&
                                <div>
                                    <h3>{t('SetShippingData.finalCopy')}</h3>
                                    <h4>{t('SetShippingData.refresh')}</h4>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
        </PageContainer>
    )
}

export default SetShippingData